import { Directive, InjectionToken } from '@angular/core';

export const APP_WARN = new InjectionToken<WarnDirective>('AppError');

@Directive({
  selector: 'app-warn',
  providers: [{ provide: APP_WARN, useExisting: WarnDirective }],
})
export class WarnDirective {}
